import { createUserWithEmailAndPassword, signInWithEmailAndPassword, updateProfile } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

export const signin = async (email, password) => {

    try {
        
        if(!email.trim()) return "Email is required."
        if(!password.trim()) return "Password is required."

        await signInWithEmailAndPassword(auth, email, password)

        return null
        
    } catch(err) {
        
        return err.message

    }

}

export const signup = async (email, password, fullnames, phone, idNumber, address) => {

    try {

        if(!email.trim()) return "Email is required."
        if(!password.trim()) return "Password is required."
        if(!fullnames.trim()) return "Fullnames is required."
        if(!idNumber.trim()) return "ID Number is required."
        if(!address.trim()) return "Address is required."

        await createUserWithEmailAndPassword(auth, email, password)

        updateProfile({
            displayName: fullnames
        })

        await setDoc(doc(db, "clients", auth.currentUser.uid), {
            email, fullnames, phone, idNumber, address
        })

        return null;

    } catch(err) {

        return err.message

    }

}